import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";

const Loader = ({ isAbsolute = false, text = "Завантаження" }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setProgress((progress) => {
        if (progress + 0.1 > 100) {
          return progress;
        } else if (progress + 0.1 > 80) {
          return progress + 0.1;
        } else if (progress + 0.1 > 60) {
          return progress + 0.5;
        } else {
          return progress + 1;
        }
      });
    }, 10);
  }, [progress]);
  return (
    <div
      className={styles.loader}
      style={{ position: isAbsolute ? "absolute" : "fixed" }}
    >
      <div className={styles.container}>
        <div> {text}</div>
        <div className={styles.progressLineCnt}>
          <div
            className={styles.progressLine}
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
